import { connect } from 'react-redux'
import MicrosoftWopiIntegrationProcessingView from './view.jsx';
import { updateNewVersionAsset, invalidateWopiIntegration } from 'src/redux/actions/microsoftWopiIntegration';

const mapStateToProps = (state, ownProps) => {
  return {
    updating: state.microsoftWopiIntegration.asset.updating,
    asset: state.microsoftWopiIntegration.asset.item,
    error: state.microsoftWopiIntegration.asset.error,
    processed: state.microsoftWopiIntegration.asset.processed
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateNewVersionAsset:(asset) =>{
      return dispatch(updateNewVersionAsset(asset));
    },
    invalidateWopiIntegration: () => {
      return dispatch(invalidateWopiIntegration());
    }
  }
}

const MicrosoftWopiIntegrationProcessingPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(MicrosoftWopiIntegrationProcessingView)

export default MicrosoftWopiIntegrationProcessingPage